import React from 'react';
import { Helmet } from 'react-helmet-async';

// Importing Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';
import Footer from '../../CommonComponent/Footer/footer';

// Importing Page Components
import HeroSectionSlider from './PageComponent/HeroSectionSlider';
import BlindsCategory from './PageComponent/BlindsCategory';

function Home() {
  return (
    <div>
      <Helmet>
        <title>Callistus Blinds | Manufacturer of Window Blinds &amp; Shades</title>
        <meta name="description"
          content="Callistus Blinds offers 15 types of window blinds, 10 operating systems &amp; 2000+ shades. Enhance your interiors with premium-quality blinds." />
        <meta name="keywords" content="window blinds, roller blinds, zebra blinds, vertical blinds, premium blinds online" />
        <link rel="canonical" href="https://callistusblinds.com/" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Callistus Blinds | Manufacturer of Window Blinds &amp; Shades" />
        <meta property="og:description"
          content="Callistus Blinds offers 15 types of window blinds, 10 operating systems &amp; 2000+ shades. Enhance your interiors with premium-quality blinds." />
        <meta property="og:url" content="https://callistusblinds.com/" />
        <meta property="og:site_name" content="Callistus Blinds" />
      </Helmet>

      <Navbar />
      <NotificationBar />
      <HeroSectionSlider />
      <BlindsCategory />
      <Footer />
    </div>
  );
}

export default Home;
